import { createAction, props } from '@ngrx/store';
import { GhUserProfileResponse } from '../../../api/administration/models/gh-user-profile-response';

export const loadUserDetails = createAction('[User Auth] Load User Details');

export const loadUserDetailsSuccess = createAction(
  '[User Auth] Load User Details Success',
  props<{ response: GhUserProfileResponse }>()
);

export const loadUserDetailsFailure = createAction(
  '[User Auth] Load User Details Failure',
  props<{ error: string }>()
);

export const resetUserAuth = createAction('[User Auth] Reset User Auth');
